export default __webpack_public_path__ + "static/myAvatar-5bb28554d8ebd94a6c201dce0dcaf5a4.png";